/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Currency_Aud3Inputs */

const he_currency_aud3 = /** @type {(inputs: Currency_Aud3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AUD - Australian Dollar`)
};

const en_currency_aud3 = /** @type {(inputs: Currency_Aud3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AUD - Australian Dollar`)
};

/**
* | output |
* | --- |
* | "AUD - Australian Dollar" |
*
* @param {Currency_Aud3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const currency_aud3 = /** @type {((inputs?: Currency_Aud3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Currency_Aud3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_currency_aud3(inputs)
	return en_currency_aud3(inputs)
});
export { currency_aud3 as "currency_AUD" }